// PageHeader — consistent page title + actions row.
export function PageHeader({ title, subtitle, actions, breadcrumbs, testId = "page-header" }) {
  return (
    <div className="mb-6" data-testid={testId}>
      {breadcrumbs && (
        <nav className="text-xs text-muted-foreground mb-2 flex gap-2 items-center">
          {breadcrumbs.map((b, i) => (
            <span key={i} className="flex items-center gap-2">
              {i > 0 && <span className="opacity-50">/</span>}
              {b.href ? <a href={b.href} className="hover:text-foreground">{b.label}</a> : <span>{b.label}</span>}
            </span>
          ))}
        </nav>
      )}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold tracking-tight break-words">{title}</h1>
          {subtitle && <p className="text-xs sm:text-sm text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-2 flex-wrap md:justify-end">{actions}</div>}
      </div>
    </div>
  );
}

export function StatCard({ label, value, hint, tone = "default", testId }) {
  const toneClass = {
    default: "",
    positive: "text-emerald-600 dark:text-emerald-400",
    negative: "text-red-600 dark:text-red-400",
    warning: "text-amber-600 dark:text-amber-400",
  }[tone];
  return (
    <div className="surface p-5" data-testid={testId}>
      <div className="label-caps">{label}</div>
      <div className={`text-2xl md:text-3xl font-heading font-bold mt-2 tabular ${toneClass}`}>{value}</div>
      {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
    </div>
  );
}

export function StatusPill({ status, label, tone }) {
  const toneMap = {
    success: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
    danger: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
    warning: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
    info: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
    neutral: "bg-zinc-100 text-zinc-800 dark:bg-zinc-800 dark:text-zinc-300",
  };
  // Otomatik renk haritası — Türkçe + İngilizce statülerin standart eşleşmesi
  const AUTO = {
    // Ödendi / tahsil / başarı — YEŞİL
    paid: "success", cleared: "success", done: "success", posted: "success",
    odendi: "success", tahsil_oldu: "success", tahsil: "success",
    // Ödenecek / bekliyor / aktif — SARI
    unpaid: "warning", partial: "warning", pending: "warning", portfolio: "warning",
    beklemede: "warning", bekliyor: "warning", aktif: "warning", active: "warning",
    // Bilgilendirici — MAVİ
    deposited: "info", handed_over: "info", ciro_edildi: "info",
    // Gecikti / ödenmedi / başarısız — KIRMIZI
    overdue: "danger", bounced: "danger", cancelled: "danger", canceled: "danger",
    disabled: "danger", failed: "danger",
    gecikti: "danger", odenmedi: "danger", iptal: "danger", iade: "danger",
    // Nötr
    draft: "neutral", dismissed: "neutral", suspended: "neutral", kapali: "neutral",
  };
  // Türkçe otomatik etiketler — özel bir label verilmediğinde bu kullanılır
  const AUTO_LABEL = {
    beklemede: "Ödenecek", bekliyor: "Ödenecek",
    aktif: "Ödenecek", active: "Ödenecek",
    pending: "Ödenecek", unpaid: "Ödenecek",
    odendi: "Ödendi", tahsil_oldu: "Tahsil Oldu", paid: "Ödendi",
    gecikti: "Gecikti", overdue: "Gecikti", odenmedi: "Ödenmedi",
    iptal: "İptal", iade: "İade", ciro_edildi: "Ciro Edildi",
    kapali: "Kapalı",
  };
  const t = tone || AUTO[status] || "neutral";
  const finalLabel = label || AUTO_LABEL[status] || status;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${toneMap[t]}`}>
      {finalLabel}
    </span>
  );
}
